import { useMutation } from "@tanstack/react-query";

import { ICard } from "../types.ts";
import { cardsAPI } from "../cardsAPI.ts";
import { queryClient } from "../../../api";
import { cardListQueryKey } from "../queries";

export const useDeleteCardMutation = () => {
  return useMutation ({
    mutationKey: ["delete-card"],
    mutationFn: async (productId: string) => {
      if (!productId) {
        throw new Error("Product ID is undefined");
      }

      const response = await cardsAPI.deleteCard(productId);

      if (!response.isProductIdDelete) {
        throw new Error("Server returned isProductIdDelete: false");
      }

      return response;
    },
    onSuccess: (response, deletedCardId, __) => {
      queryClient.setQueryData<ICard[]>([cardListQueryKey], (old) => {
        if (!old) return old;

        const deletedCard = old.find(card => card.productId === deletedCardId);
        let otherCards = old.filter(card => card.productId !== deletedCardId);

        if (deletedCard?.isMainProduct) {
          const newMainProductId = response.productIdMain;

          otherCards = otherCards.map(card => (
            card.productId === newMainProductId
              ? { ...card, isMainProduct: true } satisfies ICard
              : card
          ));
        }

        return otherCards;
      });
    },
  });
};
